import { render, staticRenderFns } from "./default.vue?vue&type=template&id=395784d0&scoped=true&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&id=395784d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395784d0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutAppBar: require('/home/vsts/work/1/s/components/layout/appBar.vue').default,LayoutFooter: require('/home/vsts/work/1/s/components/layout/footer.vue').default})
